import { createIcon } from './createIcon'

export const AirplaneIcon = createIcon({
  displayName: 'AirplaneIcon',
  viewBox: '0 0 28 24',
  path: [
    <>
      <g clipPath="url(#clip0_228_17813)">
        <path
          d="M22.6722 9C24.2799 9 27.0769 10.3594 27.0769 12C27.0769 13.6875 24.2799 15 22.6722 15H17.191L12.4667 23.2453C12.1987 23.7141 11.7004 24 11.1598 24H8.51795C8.01966 24 7.65769 23.5219 7.79402 23.0438L10.0974 15H5.26496L3.23419 17.7C3.09316 17.8875 2.86752 18 2.63248 18H0.65812C0.291453 18 0 17.7047 0 17.3438C0 17.2828 0.00940171 17.2219 0.0235043 17.1609L1.50427 12L0.0235043 6.83906C0.00470085 6.77812 0 6.71719 0 6.65625C0 6.29063 0.296154 6 0.65812 6H2.63248C2.86752 6 3.09316 6.1125 3.23419 6.3L5.26496 9H10.1021L7.79872 0.95625C7.65769 0.478125 8.01966 0 8.51795 0H11.1598C11.7004 0 12.1987 0.290625 12.4667 0.754688L17.191 9H22.6722Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_228_17813">
          <rect width="27.0769" height="24" fill="white" />
        </clipPath>
      </defs>
    </>,
  ],
})
